const CheckboxAsterisk = () => null;

export default CheckboxAsterisk;
